import { useEffect, useRef, useState } from 'react';

export const useShowUpdatedText = (updated: string | undefined) => {
  const [updateSelection, setUpdateSelection] = useState<string | undefined>();
  const [showUpdated, setShowUpdated] = useState<boolean>(false);
  const timeout = useRef<NodeJS.Timeout>();

  //we need to add updateEventNumber as a dependency to update the state on change
  useEffect(() => {
    setShowUpdated(updateSelection !== undefined);
    clearTimeout(timeout.current);
    timeout.current = undefined;
  }, [updateSelection]);

  useEffect(() => {
    setUpdateSelection(updated);
    clearTimeout(timeout.current);
    timeout.current = undefined;
  }, [updated]);

  useEffect(() => {
    timeout.current = setTimeout(() => {
      setShowUpdated(false);
    }, 2500);

    return () => {
      clearTimeout(timeout.current);
    };
  }, [showUpdated]);

  return showUpdated;
};
